export default __webpack_public_path__ + "static/media/saudi.2744a6a1.webp";